import { HttpClient } from "../api/httpclient.service";

export interface AvailableSubscription {
  id: number;
  display_name: string;
  description: string | null;
  price: number;
  subscription_package_id: number | null;
  is_trial: boolean;
  is_active_for_user: boolean;
  is_already_used: boolean;
  is_pre_paid: boolean;
}

export interface CreateSubscriptionRequest {
  user_id: number;
  subscription_package_id: number;
}

export class SubscriptionService extends HttpClient {
  constructor() {
    super();
  }

  async get_user_available_packages(user_id: number): Promise<AvailableSubscription[]> {
    try {
      const response = await this.get(`/user_subscription/get_user_available_packages?user_id=${user_id}`);
      return response;
    } catch (error: any) {
      console.error('Get available packages error:', error.response?.data || error.message);
      throw error;
    }
  }

  async create_user_subscription(payload: CreateSubscriptionRequest) {
    try {
      const response = await this.post('/user_subscription/create_user_subscription', payload);
      return response;
    } catch (error: any) {
      console.error('Create user subscription error:', error.response?.data || error.message);
      throw error;
    }
  }
}

